import yup from 'utils/yup';

export const initialAdjustBalanceFormData = {
  category: null as any,
  duration: '',
  date: undefined as undefined | null | Date,
  balance_type: { label: 'Add', value: 'add' },
  description: '',
};

export const balanceFormValidationSchema = yup.object().shape({
  category: yup.string().required(),
  date: yup.date().required().typeError({ msg: 'This must be a valid date' }),
  description: yup.string().required(),
  duration: yup.number().required(),
});
